// VaultGuard — la puerta del Vault (30/10/2026 · auditoría, 2.ª ronda, punto 6).
//
// Antes el Vault se abría con un usuario y una contraseña ESCRITOS en el JS público de roadmap.fixarr.es
// (cualquiera podía leerlos en el navegador) y el «acceso» era solo una marca en localStorage que se podía
// poner a mano. Ya no hay credenciales en el código: el Vault pide la sesión de verdad del roadmap (GitHub,
// con el registro cerrado) y, además, que sea la cuenta del dueño del proyecto.
import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Cuentas de GitHub que pueden abrir el Vault (el nombre de usuario de GitHub es público; no es un secreto).
export const DUENOS_VAULT = ['redachaudri-source'];

// Se mira la identidad de GitHub VINCULADA (la escribe Auth al entrar con GitHub), no user_metadata, que el
// propio usuario puede cambiar.
export function esDuenoVault(user) {
    const identidades = Array.isArray(user?.identities) ? user.identities : [];
    return identidades.some((i) => i?.provider === 'github'
        && DUENOS_VAULT.includes(String(i?.identity_data?.user_name || '').toLowerCase()));
}

const VaultGuard = ({ children }) => {
    const { user, isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner"></div>
                <p>Cargando...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!esDuenoVault(user)) {
        return (
            <div className="loading-screen">
                <p>El Vault es solo para el dueño del proyecto.</p>
                <p><Link to="/project/fixarr">← Volver al Roadmap</Link></p>
            </div>
        );
    }

    return children;
};

export default VaultGuard;
